<template>
	<SoftSelect v-model="valueModel" :items="langs" :label="label" />
</template>

<script lang="ts">
import { useModelValue } from "@soft-db/soft-utils";
import { defineComponent } from "vue";

export default defineComponent({
	name: "LanguageSelect",
	props: {
		modelValue: String,
		label: String,
	},
	setup(props) {
		const langs = [
			{
				text: "Français (Canada)",
				value: "fr-CA",
			},
			{
				text: "English (Canada)",
				value: "en-CA",
			},
			{
				text: "English (United States)",
				value: "en-US",
			},
		];

		const valueModel = useModelValue(props);

		return { langs, valueModel };
	},
});
</script>
